module.exports = __webpack_public_path__ + "img/service_center_002.6b996269.png";